module.exports = function getResource(label, vars = []) {
    const resources = {
        continueToCheckoutButton: 'Continue to Checkout',
        applePayButton: 'Apple Pay',
        checkoutButton: 'Checkout'
    };

    return resources[label];
};
